const mockNotifications = Array.from({ length: 20 }, (_, i) => {
    const categories = ["Pending Approvals", "System Alerts", "Payment Statuses"];
    const icons = ["alert-triangle", "server", "credit-card"];
    const colors = ["warning", "info", "danger"];
    const messages = [
        "New merchants awaiting approval",
        "System maintenance scheduled",
        "Payment issue detected",
        "API latency detected",
        "Security update required",
        "Payout failed for Merchant #4512",
        "New product submissions pending"
    ];
    const times = ["5m ago", "30m ago", "1h ago", "3h ago", "6h ago", "1d ago"];

    return {
        id: i + 1,
        category: categories[i % categories.length],
        icon: icons[i % icons.length],
        color: colors[i % colors.length],
        text: messages[i % messages.length],
        time: times[i % times.length],
        unread: Math.random() > 0.5, // Random unread status
    };
});

export default mockNotifications;
